export const AI_CREDIT_USAGE_BREAKDOWNS = [
    'feature',
    'channel',
    'user',
    'project',
    'agent',
];
//# sourceMappingURL=api.js.map